import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { constitutionalControls } from '../../data/semanticKnowledge';
import { fadeUp } from '../../utils/motion';
export function SkpControls() {
  return <section className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-1348" data-mp="3f2u2vkr06l4g">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1349" data-mp="3k1f7rxh79sz8">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-16" data-id="element-1350" data-mp="362ffmfuhavyb">
          <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl tracking-tight leading-tight" data-id="element-1351" data-mp="3a49cse5gthtq">
            Constitutional controls by design
          </h2>
          <div className="lg:col-span-7" data-id="element-1352" data-mp="3132ubzj99wxu">
            <p className="text-xl text-white/80 leading-relaxed" data-id="element-1353" data-mp="31447qanquviq">
              The Cognarchism founding charter calls for evaluative systems that
              are auditable and reviewable, with notice of adverse grounds,
              rights of appeal and correction, and pathways to restoration. SKP
              is designed to make those requirements technically enforceable.
            </p>
            <a href="https://cognarchism.org/" target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 font-semibold text-teal hover:text-white transition-colors duration-150 whitespace-nowrap" data-id="element-1354" data-mp="37rws23ovnjsr">
              Learn more about Cognarchism
              <ArrowUpRight size={18} aria-hidden="true" data-id="element-1355" data-mp="2turp4ckgn11q" />
              <span className="sr-only" data-id="element-1356" data-mp="2ov5bw34mtksx">(opens cognarchism.org in a new tab)</span>
            </a>
          </div>
        </motion.div>

        <motion.dl {...fadeUp} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 border-t border-white/15" data-id="element-1357" data-mp="32rilkq2xchwu">
          {constitutionalControls.map(control => <div key={control.title} className="border-b border-white/15 py-8" data-id="element-1358" data-mp="d4b5z9ycxn78">
              <dt className="font-heading font-bold text-xl mb-2" data-id="element-1359" data-mp="d6dufpjv389u">{control.title}</dt>
              <dd className="text-white/70 leading-relaxed" data-id="element-1360" data-mp="36vreseud3lcd">{control.body}</dd>
            </div>)}
        </motion.dl>

        <motion.div {...fadeUp} className="mt-14 border border-white/20 rounded-lg p-8 lg:p-10 max-w-4xl" data-id="element-1361" data-mp="3bx6tzq9uyxmu">
          <p className="text-lg text-white leading-relaxed mb-4" data-id="element-1362" data-mp="3kwahr7jz017o">
            The platform can administer these controls; it cannot make an
            unvalidated assessment fair simply by recording it.
          </p>
          <p className="text-white/70 leading-relaxed" data-id="element-1363" data-mp="2s86bajtkrk3x">
            Any proposed use of NCJI for role qualification or civic access
            requires evidence that its measures are fit for that use and
            procedures that allow meaningful human challenge.
          </p>
        </motion.div>
      </div>
    </section>;
}